<template>
  <div class="px-1 pt-1">
    <div class="mt-2 mb-2">
      <!-- {{ columns }}
      {{ featuresArr }} -->
      <!-- {{ featuresValidationResults }} -->
      <span
        >Załadowano: {{ featuresArr.length }} na
        {{ featuresArr.length }} obiektów{{
          activeLayer ? ' na aktywnej warstwie' : ''
        }}.
      </span>
    </div>
    <div class="modal-wrapper add-many-features">
      <AddManyFeaturesModal
        :show-add-many-features-modal="addManyFeaturesModal"
        @cancel="hideAddManyFeaturesModal()"
      ></AddManyFeaturesModal>
    </div>
    <div class="modal-wrapper add-many-features">
      <manual-import-config-modal
        :show-manual-import-config-modal="manualImportConfigModalVisible"
        @cancel="hideConfigWindow()"
      ></manual-import-config-modal>
    </div>
    <multiselect-modification-modal
      :show-multiselect-modification-modal="multiselectModificationModalVisible"
      :multiselect-modification-data="multiselectModificationData"
      @close="hideMultiselectModificationWindow"
    ></multiselect-modification-modal>
    <b-btn-toolbar class="mb-2">
      <b-btn-group class="mr-2">
        <b-btn
          v-if="editSession"
          variant="primary"
          title="Dodaj obiekt"
          @click="addFeature"
          ><icon name="plus"></icon
        ></b-btn>
        <b-btn
          v-if="editSession"
          variant="primary"
          title="Geokoduj adresy"
          @click="showAddManyFeaturesModal()"
          ><icon name="map-marked-alt"></icon
        ></b-btn>
        <b-btn
          v-if="editSession"
          variant="primary"
          title="Usuń obiekt"
          :disabled="selectedFeaturesArr.length < 1"
          @click="deleteFeatures()"
          ><icon name="trash"></icon
        ></b-btn>
        <!-- <b-btn
          variant="primary"
          title="Pokaż na mapie"
          @click="showOnMap()"
          :disabled="
            !selectedFeaturesArr.find(el => {
              return el.selected;
            })
          "
          ><icon name="crosshairs"></icon
        ></b-btn> -->
        <b-btn
          variant="primary"
          title="Ustawienia parametrów"
          @click="showConfigWindow()"
          :disabled="false"
          ><icon name="cog"></icon
        ></b-btn>
      </b-btn-group>
    </b-btn-toolbar>
    <b-row align-h="between">
      <b-col class="d-flex justify-space-between">
        <b-btn
          v-b-toggle.collapse
          variant="outline-primary"
          class="mb-2"
          @click="filterCollapsed = !filterCollapsed"
        >
          <span class="mr-1">Panel filtrów</span>
          <span
            v-if="filterCollapsed"
            class="oi oi-media-skip-forward toggle-icon"
            title="Rozwiń"
            aria-hidden="true"
          ></span>
          <span
            v-if="!filterCollapsed"
            class="oi oi-media-skip-backward toggle-icon"
            title="Zwiń"
            aria-hidden="true"
          ></span>
        </b-btn>
      </b-col>
    </b-row>
    <b-row
      ><b-col>
        <b-collapse id="collapse" class="mb-2">
          <b-card>
            <b-form @reset="clearFilters">
              <b-form-row>
                <b-col
                  class="d-flex align-items-end"
                  md="3"
                  v-for="(filter, index) in filters"
                  :key="index"
                >
                  <b-form-group
                    v-if="filter.label == 'Tylko zaznaczone'"
                    :label="filter.label"
                    label-for="filter-category"
                  >
                    <b-checkbox
                      v-model="filter.value"
                      switch
                      class="mb-2 "
                    ></b-checkbox>
                  </b-form-group>
                  <b-form-group
                    v-if="filter.label != 'Tylko zaznaczone'"
                    :label="filter.label"
                    label-for="filter-category"
                  >
                    <b-form-input
                      v-if="filter.dictionary == 0"
                      v-model="filter.value"
                      placeholder="Wyszukaj"
                    ></b-form-input>
                    <b-select
                      v-if="filter.dictionary == 1"
                      v-model="filter.value"
                      class="w-100 cursor-pointer"
                    >
                      <option :title="'Wybierz'" :value="''">Wybierz</option>
                      <option
                        v-for="dictionary in dictionariesObj[
                          filter.dictionaryName
                        ]"
                        :title="dictionary.hint || dictionary.value"
                        :key="dictionary.value"
                        :value="dictionary.value"
                        class="option-wrap"
                      >
                        {{ dictionary.hint || dictionary.value }}
                      </option>
                    </b-select>
                    <b-select
                      v-if="filter.dictionary == 2"
                      multiple
                      :select-size="3"
                      v-model="filter.value"
                      class="w-100 select-wrap cursor-pointer"
                    >
                      <option
                        v-for="dictionary in dictionariesObj[
                          filter.dictionaryName
                        ]"
                        :title="dictionary.hint || dictionary.value"
                        :key="dictionary.value"
                        :value="dictionary.value"
                      >
                        {{ dictionary.hint || dictionary.value }}
                      </option>
                    </b-select>
                    <b-select
                      v-if="filter.dictionary == 3"
                      v-model="filter.value"
                      class="w-100 cursor-pointer"
                    >
                      <option :title="'Wybierz'" :value="''">Wybierz</option>
                      <option :title="'Tak'" :value="1">Tak</option>
                      <option :title="'Nie'" :value="2">Nie</option>
                    </b-select>
                  </b-form-group>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col class="text-right">
                  <b-button
                    type="button"
                    id="applyFilters"
                    variant="primary"
                    @click="applyFilters"
                  >
                    <span v-show="showSpinner"
                      ><icon name="circle-notch" spin></icon
                    ></span>
                    <span v-show="!showSpinner">Zastosuj filtry</span>
                  </b-button>
                  <b-button type="reset" variant="outline-secondary"
                    >Wyczyść filtry</b-button
                  >
                </b-col>
              </b-form-row>
            </b-form>
          </b-card>
        </b-collapse>
      </b-col>
    </b-row>
    <b-table
      :no-border-collapse="true"
      :fields="this.columns"
      :items="this.featuresArr"
      :per-page="manualImportSettings.itemsPerPage"
      :current-page="pageNumber"
      responsive
      striped
      bordered
      :show-empty="true"
      empty-text="Brak danych"
      :tbody-tr-class="rowClass"
    >
      <template
        v-for="(column, index) in columns"
        :slot="`cell(${column.key})`"
        slot-scope="data"
      >
        <div class="feature-data-cell">
          <div
            class="modal-wrapper address-search"
            :class="{ 'dynamic-top': adressSearchModal }"
            v-if="
              activeLayerGeometryColumns.column &&
                column.key == activeLayerGeometryColumns.column[0] &&
                activeLayerGeometryColumns.column.includes(column.key) &&
                activeLayer.type === 'point'
            "
          >
            <adress-search-modal
              :show-adress-search-modal="
                adressSearchModal && data.item.id === geocodingFeatureId
              "
              @cancel="hideAdressSearchModal()"
              @submitItem="submitItem"
            ></adress-search-modal>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <div v-if="manualImportSettings.tableRawData">
              <b-form-input
                class="width200"
                v-model.lazy="data.item[column.key]"
                :title="data.item[column.key]"
                :state="
                  featuresValidationResults &&
                  featuresValidationResults[data.item.id] &&
                  featuresValidationResults[data.item.id][column.key] &&
                  !featuresValidationResults[data.item.id][column.key].isValid
                    ? false
                    : null
                "
              ></b-form-input>
            </div>
            <div
              v-if="!manualImportSettings.tableRawData"
              @change="multiselectModification(data)"
            >
              <b-form-input
                class="width200"
                v-if="column.dictionary == 0"
                :value="data.item[column.key]"
                debounce="500"
                @change="val => handleChange(val, column, data.item)"
                :title="data.item[column.key]"
                :state="
                  featuresValidationResults &&
                  featuresValidationResults[data.item.id] &&
                  featuresValidationResults[data.item.id][column.key] &&
                  !featuresValidationResults[data.item.id][column.key].isValid
                    ? false
                    : null
                "
              ></b-form-input>
              <b-select
                v-if="column.dictionary == 1"
                v-model.lazy="data.item[column.key]"
                :state="
                  featuresValidationResults &&
                  featuresValidationResults[data.item.id] &&
                  featuresValidationResults[data.item.id][column.key] &&
                  !featuresValidationResults[data.item.id][column.key].isValid
                    ? false
                    : null
                "
                class="width200 cursor-pointer"
              >
                <option :title="'Wybierz'" :value="''">Wybierz</option>
                <option
                  :title="dictionary.hint || dictionary.value"
                  v-for="dictionary in dictionariesObj[column.dictionaryName]"
                  :key="dictionary.value"
                  :value="dictionary.value"
                  class="option-wrap"
                >
                  {{ dictionary.hint || dictionary.value }}
                </option>
              </b-select>
              <b-select
                v-if="column.dictionary == 2"
                multiple
                :select-size="3"
                v-model.lazy="data.item[column.key]"
                :state="
                  featuresValidationResults &&
                  featuresValidationResults[data.item.id] &&
                  featuresValidationResults[data.item.id][column.key] &&
                  !featuresValidationResults[data.item.id][column.key].isValid
                    ? false
                    : null
                "
                class="width200 select-wrap cursor-pointer"
              >
                <option
                  :title="dictionary.hint || dictionary.value"
                  v-for="dictionary in dictionariesObj[column.dictionaryName]"
                  :key="dictionary.value"
                  :value="dictionary.value"
                >
                  {{ dictionary.hint || dictionary.value }}
                </option>
              </b-select>
              <b-select
                v-if="column.dictionary == 3"
                v-model.lazy="data.item[column.key]"
                :state="
                  featuresValidationResults &&
                  featuresValidationResults[data.item.id] &&
                  featuresValidationResults[data.item.id][column.key] &&
                  !featuresValidationResults[data.item.id][column.key].isValid
                    ? false
                    : null
                "
                class="width200 cursor-pointer"
              >
                <option :title="'Wybierz'" :value="''">Wybierz</option>
                <option :title="'Tak'" :value="1">Tak</option>
                <option :title="'Nie'" :value="2">Nie</option>
              </b-select>
            </div>

            <span
              style="word-break: break-word"
              v-if="
                featuresValidationResults[data.item.id] &&
                  featuresValidationResults[data.item.id][column.key] &&
                  !featuresValidationResults[data.item.id][column.key].isValid
              "
              class="cursor-pointer ml-1"
              v-b-tooltip="{
                title:
                  featuresValidationResults[data.item.id][column.key]
                    .description,
                boundary: 'window',
                trigger: 'hover'
              }"
            >
              <span
                style="word-break: break-word"
                class="oi oi-warning "
                :class="
                  featuresValidationResults[data.item.id][column.key].type ==
                  'Error'
                    ? 'text-danger'
                    : 'text-warning'
                "
                aria-hidden="true"
              ></span>
            </span>
          </div>
        </div>
      </template>

      <template #head(selected)="data">
        <b-form-checkbox
          @change="toggleAllSelections()"
          :checked.sync="checkedAll"
        />
      </template>
      <template #cell(selected)="data">
        <b-form-checkbox
          v-model.lazy="data.item.selected"
          :checked.sync="data.item.selected"
        />
        <b-link @click="showOnMap(data.item.id)"
          ><icon
            name="crosshairs"
            class="text-primary cursor-pointer"
            title="Wyśrodkuj"
            aria-hidden="true"
          ></icon
        ></b-link>
        <b-link
          class="mg-left-2"
          v-if="activeLayer.type === 'point'"
          @click="showAdressSearchModal(data.item.id)"
        >
          <span
            class="oi oi-map-marker text-primary  cursor-pointer"
            title="Geokoduj adres"
            aria-hidden="true"
          ></span
        ></b-link>
      </template>
      <template #cell(delete)="data">
        <b-link @click="deleteFeature(data.item.id)"
          ><icon
            name="trash"
            class="text-primary cursor-pointer"
            title="Usuń"
            aria-hidden="true"
          ></icon
        ></b-link>
      </template>
    </b-table>
    <b-row align-v="center">
      <b-col cols="4">
        Elementów na stronie: {{ elementsOnPageStart }} -
        {{ elementsOnPageEnd }} / {{ totalRows }}
      </b-col>
      <b-col cols="8">
        <b-pagination-nav
          @click.native="preventPaginatorRouteChange"
          ref="pagination"
          align="right"
          v-model="pageNumber"
          :number-of-pages="numberOfPages"
          label-first-page="Pierwsza strona"
          label-prev-page="Poprzednia strona"
          label-next-page="Następna strona"
          label-last-page="Ostatnia strona"
          label-page="Strona"
          aria-label="Paginacja"
        >
        </b-pagination-nav>
      </b-col>
    </b-row>
    <loading-overlay
      :active.sync="isLoading"
      :is-full-page="false"
    ></loading-overlay>
    <confirmation-window ref="confirmationWindow"></confirmation-window>
  </div>
</template>

<script>
// import { getUid } from 'ol/util';
import { mapGetters } from 'vuex';
import Spinner from '../Spinner';
import {
  WINDOW_NOTIFICATION_SHOW,
  FEATURES_SET,
  FEATURES_COLUMNS_SET,
  FEATURES_GEOMETRIES_SET,
  MANUAL_IMPORT_FEATURES_VALID_RULES_SET
} from '../../store/mutations.type';
import {
  EDIT_SESSION_ADD_FEATURE,
  EDIT_SESSION_DELETE_FEATURE,
  EDIT_SESSION_FOCUS_ON_FEATURE,
  EDIT_SESSION_VALIDATE_FEATURES,
  EDIT_SESSION_APPLY_MULTISELECT_MODIFICATATION
} from '../../store/actions.type';
import LoadingOverlay from 'vue-loading-overlay';
import { Api as ApiModele } from '../../api/api-modele-jakosci';
import AdressSearchModal from './AdressSearchModal.vue';
import AddManyFeaturesModal from './AddManyFeaturesModal.vue';
import ManualImportConfigModal from './ManualImportConfigModal.vue';
import MultiselectModificationModal from './MultiselectModificationModal.vue';
import ConfirmationWindow from '../ConfirmationWindow';
import { textHeights } from 'ol/render/canvas';
import moment from 'moment';
export default {
  name: 'FeaturesTable',
  components: {
    Spinner,
    LoadingOverlay,
    AdressSearchModal,
    AddManyFeaturesModal,
    ManualImportConfigModal,
    MultiselectModificationModal,
    ConfirmationWindow
  },
  props: {
    disableEditModeActions: false,
    reload: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      columns: [],
      tableColumns: [],
      pageNumber: 1,
      filterCollapsed: true,
      showSpinner: false,
      // selected:false,
      filters: {},
      mounted: false,
      allLayersColumns: [],
      dictionariesObj: null,
      adressSearchModal: false,
      addManyFeaturesModal: false,
      manualImportConfigModalVisible: false,
      geocodingFeatureId: null,
      isLoading: false,
      principlesList: [],
      multiselectModificationModalVisible: false,
      multiselectModificationData: null
    };
  },
  computed: {
    ...mapGetters([
      'editSession',
      'activeLayer',
      'features',
      'featuresColumns',
      'featuresGeometries',
      'featuresValidationResults',
      'activeLayerGeometryColumns',
      'manualImportSettings',
      'tableMeta',
      'dictionaries'
    ]),
    featuresArr: {
      get() {
        if (!this.editSession) {
          return [];
        }

        if (this.activeLayer) {
          return this.features.filter(
            feature => feature.layer === this.activeLayer.id
          );
        }
        return this.features;
      },
      set(value) {
        this.$store.commit(FEATURES_SET, value);
      }
    },
    selectedFeaturesArr() {
      if (this.featuresArr.length > 0) {
        return this.featuresArr.filter(feature => {
          if (feature.selected) {
            return feature;
          }
        });
      } else {
        return [];
      }
    },
    dependencies() {
      if (!this.activeLayer) return [];

      const currentLayerMeta = this.allLayersColumns.find(
        meta => meta.id === this.activeLayer.id
      );
      if (!currentLayerMeta) return [];

      const dependenciesRefs = currentLayerMeta.zaleznosci_refs || [];
      return dependenciesRefs.map(ref => {
        const otherDeps = this.allLayersColumns.find(
          meta => meta.id === ref.layer_id
        ).zaleznosci;

        return {
          layer_id: ref.layer_id,
          dependencies: otherDeps.filter(dep => ref.zaleznosci.includes(dep.id))
        };
      });
    },
    checkedAll() {
      if (this.featuresArr.length > 0) {
        return this.featuresArr.every(
          obj => obj.selected === true && obj.visible
        );
      }
      return false;
    },
    numberOfPages() {
      let numberOfPages = Math.ceil(
        this.totalRows / this.manualImportSettings.itemsPerPage
      );
      return numberOfPages > 0 ? numberOfPages : 1;
    },
    totalRows() {
      return this.featuresArr.length || 0;
    },
    numberOfPages() {
      let numberOfPages = Math.ceil(
        this.totalRows / this.manualImportSettings.itemsPerPage
      );
      return numberOfPages > 0 ? numberOfPages : 1;
    },
    elementsOnPageStart() {
      return (
        (this.pageNumber - 1) * this.manualImportSettings.itemsPerPage +
        (this.featuresArr.length ? 1 : 0)
      );
    },
    elementsOnPageEnd() {
      return (
        (this.pageNumber - 1) * this.manualImportSettings.itemsPerPage +
        (this.manualImportSettings.itemsPerPage * this.pageNumber >
        this.featuresArr.length
          ? this.featuresArr.length % this.manualImportSettings.itemsPerPage
          : this.manualImportSettings.itemsPerPage)
      );
    }
  },
  watch: {
    // featuresArr: {
    //   deep: true,
    //   handler() {
    // window.console.log(this.featuresArr);
    // window.console.log(this.columns);
    //   }
    // },
    // featuresArr: {
    //   deep: true,
    //   handler() {
    //     if (this.isUserInteraction) {
    //       this.$store.commit(FEATURES_SET, [
    //         ...this.featuresArr.map(obj => {
    //           const { selected, ...rest } = obj;
    //           return rest;
    //         })
    //       ]);
    //     } else {
    //       this.featuresArr = this.features.map(feature => ({
    //         ...feature,
    //         selected:
    //           newValue.find(({ id }) => id === feature.id)?.selected || false
    //       }));
    //     }
    //   }
    // },
    // features: {
    //   deep: true,
    //   handler(newValue, oldValue) {
    //     // Update featuresArr to match features
    //     this.featuresArr = newValue.map(feature => ({
    //       ...feature,
    //       selected: false
    //     }));
    //   }
    // },
    async activeLayer() {
      await this.prepareEditSession();
    },
    async editSession() {
      await this.prepareEditSession();
    },
    dictionaries(dictionariesNew) {
      if (dictionariesNew) {
        this.dictionariesObj = dictionariesNew.reduce((acc, dictionary) => {
          acc[dictionary.nazwa] = dictionary['pola'];
          return acc;
        }, {});
      }
    },
    tableMeta(tableMetaNew) {
      if (tableMetaNew) {
        this.allLayersColumns = tableMetaNew;
      }
    }
  },
  methods: {
    getDependenciesForColumn(columnKey) {
      return new Map(
        this.dependencies.map(layer => [
          layer.layer_id,
          layer.dependencies.filter(dep => dep.parent_field === columnKey)
        ])
      );
    },
    getFeaturesDependantOnFeatureColumn(editedFeature, dependencies) {
      const features = this.features
        .map(feature => {
          const dependenciesForFeatureLayer = dependencies.get(feature.layer);

          if (!dependenciesForFeatureLayer) return;
          const activeDependency = dependenciesForFeatureLayer.find(
            dep =>
              dep.dependency.startsWith('equals') &&
              feature[dep.field] === editedFeature[dep.parent_field]
          );
          if (!activeDependency) return;

          return { field: activeDependency.field, feature };
        })
        .filter(Boolean);

      return features;
    },
    updateDependantFeatures(features, newValue) {
      features.forEach(({ field, feature }) => (feature[field] = newValue));
    },
    handleChange(value, column, editedFeature) {
      const dependantFeatures = this.getFeaturesDependantOnFeatureColumn(
        editedFeature,
        column.dependencies
      );
      this.updateDependantFeatures(dependantFeatures, value);
      editedFeature[column.key] = value;
    },
    async prepareEditSession() {
      if (this.editSession) {
        this.getColumns();
        this.createFilters();
        await this.getModeleJakosci();
        this.getModeleJakosciById();
      }
    },
    async getColumns() {
      const featuresColumns = this.allLayersColumns.reduce((acc, layerMeta) => {
        const { id, kolumny } = layerMeta;

        const columns = kolumny.map(column => ({
          key: column.nazwa,
          label: column.etykieta[0].toUpperCase() + column.etykieta.slice(1),
          dictionary: column.slownik,
          dictionaryName: column.nazwa_slownika || '',
          sortable: true,
          tdClass: 'width10',
          thClass: 'width10',
          dependencies: this.getDependenciesForColumn(column.nazwa)
        }));

        return { ...acc, [id]: columns };
      }, {});

      this.columns = featuresColumns[this.activeLayer.id];
      this.$store.commit(FEATURES_COLUMNS_SET, featuresColumns);
      this.addCheckboxColumn();
      this.addDeleteColumn();
    },

    async getModeleJakosci() {
      try {
        const api = new ApiModele();
        const response = await api.getModeleJakosci({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          page_number: 1,
          items_per_page: 100,
          order_by: '',
          desc: true,
          filter_str: '',
          tylko_aktywne: true
        });
        if (response) {
          this.principlesList = response.body.modele_jakosci;
        }
      } catch (err) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.'
        });
      }
    },
    async getModeleJakosciById() {
      const activeLayerPrinciple = this.principlesList.find(el => {
        return el.warstwa.id === this.activeLayer.id;
      });
      try {
        const api = new ApiModele();
        const response = await api.getModeleJakosciById({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          id: activeLayerPrinciple.id
        });
        if (response) {
          this.featuresValidRules = response.body.modele_jakosci.reguly_jakosci.reduce(
            (obj, item) => {
              if (!obj[item.field]) {
                obj[item.field] = [];
              }

              const newObjItem = item;
              obj[item.field].push(newObjItem);

              return obj;
            },
            {}
          );
          if (
            this.featuresValidRules.geometry &&
            this.activeLayerGeometryColumns &&
            this.activeLayerGeometryColumns.column
          ) {
            this.activeLayerGeometryColumns.column.forEach(column => {
              this.featuresValidRules[
                column
              ] = this.featuresValidRules.geometry;
            });
          }

          this.$store.commit(
            MANUAL_IMPORT_FEATURES_VALID_RULES_SET,
            this.featuresValidRules
          );
        }
      } catch (error) {
        this.$store.commit(WINDOW_NOTIFICATION_SHOW, {
          message: error,
          type: 'error',
          title: 'Uwaga.'
        });
      }
    },
    setTooltips() {
      var paginationButtons = Array.from(
        document.getElementsByClassName('page-item')
      );

      var firsts = paginationButtons.filter(
        pb => pb.innerText.indexOf('«') != -1
      );
      var previous = paginationButtons.filter(
        pb => pb.innerText.indexOf('‹') != -1
      );
      var nexts = paginationButtons.filter(
        pb => pb.innerText.indexOf('›') != -1
      );
      var lasts = paginationButtons.filter(
        pb => pb.innerText.indexOf('»') != -1
      );

      firsts.forEach(item => (item.title = 'Pierwsza'));
      previous.forEach(item => (item.title = 'Poprzednia'));
      nexts.forEach(item => (item.title = 'Następna'));
      lasts.forEach(item => (item.title = 'Ostatnia'));
    },
    preventPaginatorRouteChange(event) {
      event.preventDefault();
    },
    validateFeatures() {
      this.$store.dispatch(EDIT_SESSION_VALIDATE_FEATURES);
    },

    toggleAllSelections() {
      if (
        this.featuresArr.length > 0 &&
        this.featuresArr.some(feature => {
          return feature.selected == false;
        })
      )
        this.featuresArr = this.featuresArr.map(feature => {
          if (feature.visible) {
            feature.selected = true;
          }

          return feature;
        });
      else {
        this.featuresArr = this.featuresArr.map(feature => {
          if (feature.visible) {
            feature.selected = false;
          }

          return feature;
        });
      }
    },
    addMany(numb) {
      for (let i = 0; i < numb; i++) {
        window.console.log(i + 1);
        this.addFeature();
      }
    },
    addFeature(atributes) {
      this.$store.dispatch(EDIT_SESSION_ADD_FEATURE, atributes);
    },
    deleteFeatures() {
      this.featuresArr.forEach(feature => {
        if (feature.selected && feature.visible) {
          this.deleteFeature(feature.id);
        }
      });
    },
    deleteFeature(featureId) {
      const self = this;
      const confirmationWindow = self.$refs.confirmationWindow;
      confirmationWindow.setMessage('Czy na pewno chcesz usunąć ten obiekt?');
      confirmationWindow.setYesAction(function() {
        self.$store.dispatch(EDIT_SESSION_DELETE_FEATURE, featureId);
      });
      confirmationWindow.setNoAction();
      confirmationWindow.show();
    },
    addCheckboxColumn() {
      const selectColumn = {
        key: 'selected',
        label: ''
      };
      this.columns.unshift({ ...selectColumn });
    },
    addDeleteColumn() {
      const selectColumn = {
        key: 'delete',
        label: ''
      };
      this.columns.push({ ...selectColumn });
    },
    rowClass(item, type) {
      return item && item.visible ? '' : 'd-none';
    },
    showOnMap(featureId) {
      this.$store.dispatch(
        EDIT_SESSION_FOCUS_ON_FEATURE,
        featureId ||
          this.featuresArr.find(feature => {
            return feature.selected && feature.visible;
          }).id
      );
    },
    showAdressSearchModal(id) {
      this.hideAdressSearchModal();
      this.geocodingFeatureId = id;
      this.adressSearchModal = true;
    },
    hideAdressSearchModal() {
      this.adressSearchModal = false;
    },
    submitItem(item) {
      if (item.x && item.y) {
        this.editFeatureGeometryInArr([item.x, item.y]);
      }
      if (item.simc) {
        this.editFeatureSimcInArr(item.simc);
      }
      if (item.streetSymbol) {
        this.editFeaturUlicInArr(item.streetSymbol);
      }
      if (item.teryt) {
        this.editFeatureTercInArr(item.teryt);
      }
      if (item.number) {
        this.editFeatureAddressNumberInArr(item.number);
      }
    },
    editFeatureGeometryInArr(coordinates) {
      const newFeature = this.featuresArr.find(featureArr => {
        if (featureArr.id == this.geocodingFeatureId) {
          return featureArr;
        }
      });
      let geometryColumn = null;
      let geometryCenterCoordinates = null;
      switch (this.activeLayer.type) {
        case 'point':
          geometryCenterCoordinates = coordinates.map(coordinate => {
            return parseInt(coordinate);
          });
          if (this.activeLayerGeometryColumns.column.length == 1) {
            geometryColumn = this.activeLayerGeometryColumns.column[0];
            newFeature[
              geometryColumn
            ] = `POINT(${coordinates[0]} ${coordinates[1]})`;
          }
          if (this.activeLayerGeometryColumns.column.length == 2) {
            const geometryColumn1 = this.activeLayerGeometryColumns.column[0];
            const geometryColumn2 = this.activeLayerGeometryColumns.column[1];
            newFeature[geometryColumn1] = coordinates[0];
            newFeature[geometryColumn2] = coordinates[1];
          }
          break;
          // case 'linestring':
          //   geometryColumn = this.activeLayerGeometryColumns.column[0];
          //   const coordinateStrings = coordinates.map(
          //     coord => `${coord[0]} ${coord[1]}`
          //   );
          //   const coordinateString = coordinateStrings.join(', ');
          //   //eb is linie kablove and they have diferent geometry write
          //   if (this.activeLayer.id == 'eB') {
          //     newFeature[geometryColumn] = coordinateString;
          //   } else {
          //     newFeature[geometryColumn] = `LINESTRING(${coordinateString})`;
          //   }

          //   break;
          // case 'polygon':
          geometryColumn = this.activeLayerGeometryColumns.column[0];
          const polygonStrings = coordinates.map(polygon =>
            polygon.map(coord => `${coord[0]} ${coord[1]}`).join(', ')
          );
          const polygonString = `POLYGON((${polygonStrings.join('), (')}))`;
          newFeature[geometryColumn] = polygonString;
          break;
      }
      newFeature.validGeometry = true;
      newFeature.center = geometryCenterCoordinates;
      this.featuresArr = this.featuresArr.map(featureArr => {
        if (featureArr.id == this.geocodingFeatureId) {
          featureArr = newFeature;
        }
        return featureArr;
      });
    },
    editFeatureSimcInArr(simc) {
      this.featuresArr = this.featuresArr.map(featureArr => {
        if (featureArr.id == this.geocodingFeatureId) {
          const simcCol = this.columns.find(el => {
            if (el.label.toLowerCase().includes('simc')) {
              return el;
            }
          });
          const simcColKey = simcCol && simcCol.key ? simcCol.key : null;
          if (simcColKey) {
            featureArr = { ...featureArr, [simcColKey]: simc };
          }
        }
        return featureArr;
      });
    },
    editFeaturUlicInArr(ulic) {
      this.featuresArr = this.featuresArr.map(featureArr => {
        if (featureArr.id == this.geocodingFeatureId) {
          const ulicCol = this.columns.find(el => {
            if (
              el.label.toLowerCase().includes('ulic') ||
              el.label.toLowerCase().includes('numer drogi')
            ) {
              return el;
            }
          });
          const ulicColKey = ulicCol && ulicCol.key ? ulicCol.key : null;

          if (ulicColKey) {
            featureArr = { ...featureArr, [ulicColKey]: ulic };
          }
        }
        return featureArr;
      });
    },
    editFeatureTercInArr(terc) {
      this.featuresArr = this.featuresArr.map(featureArr => {
        if (featureArr.id == this.geocodingFeatureId) {
          const tercCol = this.columns.find(el => {
            if (
              el.label.toLowerCase().includes('terc') ||
              el.label.toLowerCase().includes('teryt')
            ) {
              return el.key;
            }
          });
          const tercColKey = tercCol && tercCol.key ? tercCol.key : null;
          if (tercColKey) {
            featureArr = { ...featureArr, [tercColKey]: terc };
          }
        }
        return featureArr;
      });
    },
    editFeatureAddressNumberInArr(addressNumber) {
      this.featuresArr = this.featuresArr.map(featureArr => {
        if (featureArr.id == this.geocodingFeatureId) {
          const addressNumberCol = this.columns.find(el => {
            if (el.label.toLowerCase().includes('porządkowy')) {
              return el.key;
            }
          });
          const addressNumberColKey =
            addressNumberCol && addressNumberCol.key
              ? addressNumberCol.key
              : null;
          if (addressNumberColKey) {
            featureArr = {
              ...featureArr,
              [addressNumberColKey]: addressNumber
            };
          }
        }
        return featureArr;
      });
    },
    showAddManyFeaturesModal() {
      this.addManyFeaturesModal = true;
    },
    hideAddManyFeaturesModal() {
      this.addManyFeaturesModal = false;
    },
    createFilters() {
      this.filters = [];
      this.columns.forEach(column => {
        if (column.key == 'selected') {
          this.filters.push({
            label: 'Tylko zaznaczone',
            key: column.key,
            value: false
          });
        } else {
          if (column.dictionary == 0) {
            this.filters.push({
              dictionary: column.dictionary,
              dictionaryName: column.dictionaryName,
              label: column.label,
              key: column.key,
              value: ''
            });
          }
          if (column.dictionary == 1) {
            this.filters.push({
              dictionary: column.dictionary,
              dictionaryName: column.dictionaryName,
              label: column.label,
              key: column.key,
              value: ''
            });
          }
          if (column.dictionary == 2) {
            this.filters.push({
              dictionary: column.dictionary,
              dictionaryName: column.dictionaryName,
              label: column.label,
              key: column.key,
              value: []
            });
          }
          if (column.dictionary == 3) {
            this.filters.push({
              dictionary: column.dictionary,
              dictionaryName: column.dictionaryName,
              label: column.label,
              key: column.key,
              value: ''
            });
          }
        }
      });
    },
    clearFilters() {
      this.createFilters();
      this.applyFilters();
    },
    applyFilters() {
      this.featuresArr = this.featuresArr.map(feature => {
        if (this.checkIfPassFilter(feature)) {
          feature.visible = true;
        } else {
          feature.visible = false;
        }
        return feature;
      });
    },
    checkIfPassFilter(feature) {
      const passFilter = this.filters.every(filter => {
        const featureValue = feature[filter.key];
        const filterValue = filter.value;
        if (filter.key === 'selected') {
          return filterValue ? featureValue === filterValue : true;
        } else {
          if (filter.dictionary == 0) {
            return featureValue.includes(filterValue);
          }
          if (filter.dictionary == 1) {
            return featureValue.includes(filterValue);
          }
          if (filter.dictionary == 2) {
            return filterValue.every(element => {
              return featureValue.includes(element);
            });
          }
          if (filter.dictionary == 3) {
            return featureValue.includes(filterValue);
          }
        }
      });
      return passFilter;
    },
    showConfigWindow() {
      this.manualImportConfigModalVisible = true;
    },
    hideConfigWindow() {
      this.manualImportConfigModalVisible = false;
    },
    showMultiselectModificationWindow() {
      this.multiselectModificationModalVisible = true;
    },
    hideMultiselectModificationWindow() {
      this.multiselectModificationModalVisible = false;
    },
    multiselectModification(data) {
      if (
        !this.activeLayerGeometryColumns.column ||
        !this.activeLayerGeometryColumns.column.includes(data.field.key)
      ) {
        this.multiselectModificationData = data;
        if (this.manualImportSettings.multiselectModification.notification) {
          const isMultiselectModification =
            data.item.selected &&
            data.item.visible &&
            this.features.filter(feature => {
              return feature.selected && feature.visible;
            }).length > 1;
          if (isMultiselectModification) {
            this.showMultiselectModificationWindow();
          }
        } else {
          if (this.manualImportSettings.multiselectModification.value)
            this.$store.dispatch(
              EDIT_SESSION_APPLY_MULTISELECT_MODIFICATATION,
              this.multiselectModificationData
            );
        }
        this.$emit('edited-data');
      }
    }
  },
  mounted() {
    // this.columns = [...this.featuresColumns];

    this.featuresArr = [];
    this.setTooltips();
    this.mounted = true;
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer !important;
}
.feature-data-cell {
  position: relative;
}
.modal-wrapper {
  z-index: 1;
  position: absolute;
}
.address-search {
  width: 300%;

  top: calc(-100% - 10px);
  transform: translate(-140%, 20px);
}

.option-wrap {
  max-width: 100%;
  white-space: normal;
  word-wrap: break-word !important;
}
.mg-left-2 {
  margin-left: 2px;
}
.width200 {
  width: 200px !important;
}
/* .table-responsive th{
  width: 300px;
} */
</style>
